<template>
    <div v-if="storification" id="screen-instagram" ref="screen-instagram" class="preview-share-after-post background-img">
        <img crossorigin="anonymous" v-if="storification.image" class="share-img" :src="storification.image" alt="" @load="shareLoadImage" @error="shareLoadErrorImage">
        <p class="share-username" v-if="storification.image">@{{storification.username}}</p>
        <img :hidden="!storification.isCarousel" class="carousel-storification" src="../../assets/img/carousel.svg"/>
        <div v-if="link && link.url && link.isActive" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid} colorable-${_uid} link-container-view style-color-0`" data-name="Link" :data-init="link.initialDatas && JSON.stringify(link.initialDatas)"> 
            <img class="link-img" src="../../assets/img/icon_instagram_link.svg" alt="Link">
            <p class="link-txt">{{link.text ? link.text.toUpperCase() : link.url.split('/')[2].toUpperCase().split('?')[0].replace('WWW.', '')}}</p>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
        </div>
    </div>
</template>

<script>
import ColorThief from 'color-thief-browser'
import interact from "interactjs";

const screenSize = {width: 360, height: 640}

export default {
    mounted() {

        console.log("MOUNT STORIFICATION", this._uid);
        if (!this.preview) {
            interact(`.interactable-${this._uid}`)
            .draggable({
                allowFrom: `.draggable-${this._uid}`,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: this.$refs['screen-instagram'],
                    })
                ],
                listeners: {
                    move: this.moveDraggable,
                    end: this.updateStoreWithPosition
                }
            })
            .resizable({
                allowFrom: `.resizable-${this._uid}`,
                edges: { left: '.edge-left', right: '.edge-right', bottom: '.edge-bottom', top: '.edge-top'},
                listeners: { 
                    move: this.moveResizable,
                    end: this.updateStoreWithPosition
                },
                modifiers: [
                    interact.modifiers.restrictEdges({
                        outer: this.$refs['screen-instagram'],
                    }),
                    interact.modifiers.restrictSize({
                        min: { width: 50, height: 10 },
                        max: { width: 300, height: 55 }
                    }),
                    interact.modifiers.aspectRatio({
                        ratio: 'preserve'
                    })
                ]
            })
            .pointerEvents({
                allowFrom: `.colorable-${this._uid}`
            })
            .on('tap', this.changeColor);
            
        }
        this.initDatas();

    },
    watch: {
        preview(newVal, oldVal) {
            if (newVal) {
                for (const [key, value] of Object.entries(newVal)) {
                    this.updatePreview(key, value);
                }
            }
        },
        link(newVal, oldVal) {
            if (!oldVal || !oldVal.url || !oldVal.isActive) {
                this.$nextTick(this.initDatas);
            }
        } 
    },
    data() {
        return {
      
        }
    },
    props: {
        storification: Object,
        link: Object,
        preview: {type: Object, default: null}
    },
    methods: {

        moveDraggable(event) {
            let x = parseFloat(event.target.getAttribute('data-x') || (event.target.offsetWidth/2));
            let y = parseFloat(event.target.getAttribute('data-y') || (event.target.offsetHeight/2));
            x += event.dx;
            y += event.dy;
            event.target.setAttribute("data-x", x);
            event.target.setAttribute("data-y", y);
            // event.target.style.transform = `translate(${x}px, ${y}px)`
            event.target.style.top = `${y - (event.target.offsetHeight/2)}px`;
            event.target.style.left = `${x - (event.target.offsetWidth/2)}px`;
        },

        moveResizable(event) {
            let scale = parseFloat(event.rect.width/(event.target.style.width || 146))
            if (scale > 2) scale = parseFloat(event.target.getAttribute('data-scale') || 1);
            event.target.setAttribute("data-scale", scale);
            event.target.style.scale = scale;
        },

        changeColor(event, color=null) {
            let element = event.currentTarget;
            [...element.classList].some(e => {
                console.log(e);
                if (/style-color-[0-3]/.test(e)) {
                    if (color === null) color = (parseInt(e.split('-').pop()) + 1) % 4;
                    console.log("OK", color);
                    element.classList.remove(e);
                    element.classList.add(`style-color-${color}`)
                    return true;
                }
            });
            if (!color) color = 0;
            let name = element.getAttribute('data-name');
            this.$store.commit(`updateStorification${name}`, {color})
        },

        updateStoreWithPosition(event) {
            let x = parseFloat(event.target.getAttribute('data-x') || (event.target.offsetWidth/2));
            let y = parseFloat(event.target.getAttribute('data-y') || (event.target.offsetHeight/2));
            let scale = parseFloat(event.target.getAttribute('data-scale') || 1);
            let name = event.target.getAttribute('data-name')
            this.$store.commit(`updateStorification${name}`, {x, y, scale})
        },

        updatePreview(name, values) {
            console.log(this.$el,this.$el.querySelector);
            let elmt = this.$el.querySelector(`[data-name="${name}"]`);
            if (elmt && values) {
                elmt.style.top = `${values.y - (elmt.offsetHeight/2)}px`;
                elmt.style.left = `${values.x - (elmt.offsetWidth/2)}px`;
                elmt.style.scale = values.scale;
                (values.color || values.color === 0) && [...elmt.classList].some(e => /style-color-[0-3]/.test(e) && (elmt.classList.remove(e) || elmt.classList.add(`style-color-${values.color}`)));
            }
        },

        shareLoadErrorImage(e, origin=false) {
            console.log("@error=shareLoadErrorImage origin:", origin);
            let img = e.target;
            if (origin) {
                img.crossOrigin = undefined;
            }
            img.onerror = () => this.shareLoadErrorImage(e, true);
            if (!img.src.includes("timestamp")) {
                img.src += `?timestamp=${new Date().getTime()}`
            }
            img.style.backgroundColor = 'white';
        },

        shareLoadImage(e) {
            let colors
            try {
                let colorThief = new ColorThief();
                colors = colorThief.getPalette(e.target, 5).map(c => {
                return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
                })
            } catch(err) {
                console.log(err);
                colors = [`rgb(0,0,0)`, `rgb(0,0,0)`]
            }
            e.target.parentElement.style =  `background: linear-gradient(${colors[0]}, ${colors[1]})`;
            e.target.nextSibling.style = `top: ${e.target.parentElement.offsetHeight/2 + e.target.height/2 + 10}px`;
            e.target.parentElement.getElementsByClassName("carousel-storification")[0].style = `top: ${e.target.parentElement.offsetHeight/2 - e.target.height/2 + 7}px; left: ${e.target.parentElement.offsetWidth/2 + e.target.width/2 - 30}px;`
        },

        initDatas() {
            this.$el.querySelectorAll(`.colorable-${this._uid}`).forEach(element => {
                //Init default values
                let color = 0;

                // Get Initial give value if exists
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.color) {
                        color = initialDatas.color
                    }
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, color);

                //Init color
                this.changeColor({currentTarget: element}, color)
            });
            this.$el.querySelectorAll(`.draggable-${this._uid}`).forEach(element => {
                //Init default values
                let x = (screenSize.width / 2);
                let y = (screenSize.height / 4);
                
                // Get Initial give value if exists
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.x && initialDatas.y) {
                        ({ x, y } = initialDatas);
                    }
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, x, y);

                //Init position
                element.setAttribute("data-x", x)
                element.setAttribute("data-y", y)
                const evt = {dx: 0, dy: 0, target: element};
                this.moveDraggable(evt);
                this.updateStoreWithPosition(evt);
            });
            this.$el.querySelectorAll(`.resizable-${this._uid}`).forEach(element => {
                //Init default values
                let scale = 1;
                
                // Get Initial give value if exists
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.scale) {
                        scale = initialDatas.scale;
                    }
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, scale);

                //Init position
                element.setAttribute("data-scale", scale)
                const evt = {target: element, rect: {width: Infinity}};
                this.moveResizable(evt);
                this.updateStoreWithPosition(evt);
            });
        
        }
        
    }
}
</script>